import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { LOADING } from "../../../types";
import { ProgrammaState } from "../types/state";
import { TalesProgramma } from "../../../utils/types/TalesProgramma";

export const getProgrammaState = (state: RootState): ProgrammaState =>
  state.programma;

export const getProgrammaData = createSelector(
  getProgrammaState,
  (programmaState): TalesProgramma[] | null => programmaState?.data,
);

export const getProgrammaError = createSelector(
  getProgrammaState,
  (programmaState): string | null => programmaState?.error,
);

export const isProgrammaLoading = createSelector(
  getProgrammaState,
  (programmaState): boolean =>
    programmaState?.loading === LOADING.PENDING ?? false,
);
